const forms = {
  form1: {
    identity: 'Identité',
    civility: 'Civilité',
    maam: 'Madame',
    sir: 'Monsieur',
    companyName: "Nom de l'entreprise",
    firstName: 'Prénom',
    lastName: 'Nom',
    companyNameErrorText: 'Veuillez saisir le nom de l’entreprise',
  },
  form2: {
    alreadyAClient: 'Déja client',
    yes: 'Oui',
    no: 'Non',
    accountNumber: 'N°compte',
  },
  form3: {
    coordinates: 'Coordonnées',
    phoneNumber: 'Numéro de téléphone',
    emailAddress: 'Email',
    zipCode: 'Code postal',
    address: 'Adresse',
    city: 'Ville',
  },
  form4: {
    message: 'Message',
    generalConditions1:
      "J'ai lu et j'accepte les conditions générales d'utilisation, notamment la mention relative à la protection des données personnelles.",
    generalConditions2:
      "Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données personnelles.",
    objet: 'Objet',
    readGeneralConditions: "Lire conditions générales d'utilisation",
  },
  form51: {
    financingDetails: 'Détail du financement',
    financingType: 'type de financement',
    financingSubType: 'Sous-type',
    activity: 'Activité',
    amount: 'Montant',
    duration: 'Durée(Mois)',
    contribution: 'Apport',
  },
  form52: {
    projectDescription: 'Description du projet',
    description: 'Description',
  },
  common: {
    copyright:
      'COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS',
    headerTitle: 'Prenez un rendez-vous',
    goback: 'Retour',
    formsSubTitle: 'Merci de remplir le formulaire ci-dessous',
    generalConditions1:
      "J'ai lu et j'accepte les conditions générales d'utilisation, notamment la mention relative à la protection des données personnelles.",
    generalConditions2:
      "Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données personnelles.",
    readGeneralConditions: "Lire conditions générales d'utilisation",
  },
};

export default forms;
